import styled from "styled-components";
import {GRAY} from "../../../../_shared/colors";
import {
  FONT_FAMILY_BOLD,
  FONT_FAMILY_REGULAR,
} from "../../../../portal/views/SSDDashboardView/styles/globals";

export const QuestionIcon = styled.div`
  font-size: 2rem;
`;

export const Question = styled.div`
  font-family: ${FONT_FAMILY_BOLD};
  font-size: 1.5rem;
`;

export const QuestionHelper = styled.div`
  font-family: ${FONT_FAMILY_REGULAR};
  font-size: 0.85rem;
  color: ${GRAY};
`;

export const ProductDiscoveryStepContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const RecommendationTitle = styled.div`
  font-size: 1.5rem;
  font-family: ${FONT_FAMILY_BOLD};
  margin-top: 1rem;
`;

export const RecommendationSubtitle = styled.div`
  font-size: 1rem;
  font-family: ${FONT_FAMILY_REGULAR};
  margin: 1rem 0;
  color: ${GRAY};
`;
